import { Pipe, PipeTransform } from '@angular/core';
import { FormatPipe } from 'ngx-date-fns';

@Pipe({
  name: 'ordinal',
  standalone: true,
})
export class OrdinalPipe implements PipeTransform {
  constructor(private readonly formatPipe: FormatPipe) {}

  transform(number: number): string {
    return this.formatPipe.transform(new Date(1970, 0, number), 'do');
  }
}
